module.exports = __webpack_public_path__ + "img/927205926.4532e6b7.jpg";